import _ from 'lodash';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { NavLink, withRouter } from 'react-router-dom';

import placeholderBackground from '../../../../assets/images/placeholder-background.png';
import placeholderImage from '../../../../assets/images/placeholder.jpg';
import { config } from '../../../../config/index';
import { GET, newFetch } from '../../../../helpers/fetch';

const { SERVER_URL } = config;

const EventDetail = ({
  history,
  match: {
    params: { event_id },
  },
}) => {
  const [event, setEvent] = useState(null);

  const fetchEvent = async () => {
    let api_path = `/event/${event_id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setEvent(response.data);
    }
  };

  const formatUrl = (url) => {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return `https://${url}`;
    }
    return url;
  };

  useEffect(() => {
    fetchEvent();
  }, []);

  return (
    <>
      {event && (
        <div style={{ paddingTop: '3rem', marginBottom: '6rem' }}>
          <div
            className="d-flex flex-column"
            style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
          >
            <NavLink
              to="/events"
              className="text-decoration-none"
              style={{ color: 'inherit' }}
            >
              <div style={{ color: '#5156BE' }}>
                <i className="fas fa-chevron-left pe-2"></i>Back to Events
              </div>
            </NavLink>
            <div className="d-flex justify-content-between pt-4">
              <h5>Event ID: {event ? event.event_id : ''}</h5>
              <button
                className="btn btn-brand adjust-fs adjust-shadow"
                style={{ width: '150px' }}
                onClick={() => history.push(`${event_id}/edit`)}
              >
                Edit Event
              </button>
            </div>
          </div>
          <div
            className="d-flex"
            style={{
              marginTop: '2rem',
              marginLeft: '3rem',
              marginRight: '3rem',
            }}
          >
            <div className="flex-grow-1">
              <div className="rounded adjust-shadow bg-white">
                <div className="p-4 d-flex flex-column">
                  <div className="d-flex flex-column">
                    <div>
                      {
                        <Carousel showStatus={false} showThumbs={false}>
                          {event.images.length > 0 ? (
                            event.images.map((image, index) => (
                              <div
                                key={index}
                                style={{
                                  height: '350px',
                                  alignContent: 'center',
                                }}
                              >
                                <img
                                  style={{ maxWidth: '100%', height: '100%' }}
                                  src={`${SERVER_URL}/${image.url}`}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = placeholderBackground;
                                    e.target.style.height = '45%';
                                  }}
                                  alt=""
                                />
                              </div>
                            ))
                          ) : (
                            <div style={{ height: '350px' }}>
                              <img
                                src={placeholderBackground}
                                alt=""
                                style={{ maxWidth: '100%', maxHeight: '45%' }}
                              />
                            </div>
                          )}
                        </Carousel>
                      }
                    </div>
                    <h4 className="pt-4">{event.title}</h4>
                    <p className="pt-2">{event.description}</p>
                    <strong className="pt-2">Event Venue</strong>
                    <p className="pt-2">{event.event_venue}</p>
                    <strong className="pt-2">Date and Timing</strong>
                    <p className="pt-2">
                      {`${moment(event.date).format(
                        'DD MMM YYYY, hh:mma'
                      )} - ${moment(event.date)
                        .add(event.duration, 'hours')
                        .format('DD MMM YYYY, hh:mma')}`}
                    </p>
                    <strong className="pt-2">Duration</strong>
                    <p className="pt-2">
                      {event.duration
                        ? `${event.duration} hour${
                            event.duration > 1 ? `s` : ''
                          }`
                        : '-'}
                    </p>
                    <strong className="pt-2">Event URL</strong>
                    <p className="pt-2">
                      <a
                        href={formatUrl(event.url)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {event.url}
                      </a>
                    </p>
                    <strong className="pt-2">Contact Info</strong>
                    <p className="pt-2">
                      {event.contact ? event.contact : '-'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="d-flex flex-column"
              style={{ minWidth: '250px', width: '250px', marginLeft: '2rem' }}
            >
              <strong>Date Created</strong>
              <div className="pt-2">
                {moment(event.createdAt).format('DD MMMM YYYY')}
              </div>
              <strong className="pt-4">Created By</strong>
              <div className="d-flex align-items-center my-1 py-1 rounded">
                <div className="me-2">
                  <img
                    className="img-responsive rounded-circle border"
                    src={
                      event.creator.image
                        ? `${SERVER_URL}/${event.creator.image}`
                        : placeholderImage
                    }
                    alt="username-img"
                    style={{ height: '35px', width: '35px' }}
                  />
                </div>
                <div className="d-flex justify-content-between align-items-center w-100">
                  <div>
                    {_.truncate(
                      `${event.creator.first_name} ${event.creator.last_name}`,
                      { length: 18 }
                    )}
                  </div>
                </div>
              </div>
              <strong className="pt-4">Recipients</strong>
              {event.associates.length > 0 &&
                event.associates.map((associate, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-center my-1 py-1 rounded"
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      associate?.event_associate?.associate_id &&
                      history.push(
                        `/associates/associate/${associate?.event_associate?.associate_id}`
                      )
                    }
                  >
                    <div className="me-2">
                      <img
                        className="img-responsive rounded-circle border"
                        src={
                          associate.image
                            ? `${SERVER_URL}/${associate.image}`
                            : placeholderImage
                        }
                        alt="username-img"
                        style={{ height: '35px', width: '35px' }}
                      />
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div>
                        {_.truncate(
                          `${associate.first_name} ${associate.last_name}`,
                          { length: 18 }
                        )}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default withRouter(EventDetail);
